import React from "react";
import { BiRightArrowAlt, BiLeftArrowAlt } from "react-icons/bi";


class Carousel extends React.Component {
  constructor(props) {
    // console.log("carouse");
    super(props);
    this.state = {
      items: this.props.items,
      active: this.props.active,
      direction: "",
    };
    this.rightClick = this.moveRight.bind(this);
    this.leftClick = this.moveLeft.bind(this);
  }

  generateItems() {
    var items = [];
    var level;
    for (var i = this.state.active - 2; i < this.state.active + 3; i++) {
      var index = i;
      if (i < 0) {
        index = this.state.items.length + i;
      } else if (i >= this.state.items.length) {
        index = i % this.state.items.length;
      }
      level = this.state.active - i;
      items.push(
        <Item
          key={index}
          id={this.state.items[index]}
          level={level}
          item={this.state.items[index]}
        />
      );
    }
    return items;
  }

  moveLeft() {
    var newActive = this.state.active;
    newActive--;
    this.setState({
      active: newActive < 0 ? this.state.items.length - 1 : newActive,
      direction: "left",
    });
  }

  moveRight() {
    var newActive = this.state.active;
    this.setState({
      active: (newActive + 1) % this.state.items.length,
      direction: "right",
    });
  }

  render() {
    return (
      <div id="carousel" className="noselect">
        <div className="arrow arrow-left" onClick={this.leftClick}>
          <BiLeftArrowAlt color="white" size={30} />
        </div>
        {/* <ReactCSSTransitionGroup transitionName={"left"}> */}
        {this.generateItems()}
        {/* </ReactCSSTransitionGroup> */}
        <div className="arrow arrow-right" onClick={this.rightClick}>
          <BiRightArrowAlt color="white" size={30} />
        </div>
      </div>
    );
  }
}

class Item extends React.Component {
  constructor(props) {
    // console.log(props);
    super(props);
    this.state = {
      level: this.props.level,
      item: this.props.item,
    };
  }

  render() {
    const className = "item level" + this.props.level;
    return (
      <div
        className={className}
        onClick={() => {
          window.open(
            `https://www.myirelandbox.com/${this.state.item.slug}`,
            "_self"
          );
        }}
      >
        <div
          className="past-box1-img"
          style={{
            backgroundImage: `url(${this.state.item.featured_image_url})`,
          }}
        >
          {/* <img src={Box} /> */}
        </div>
        <div className="past-box1-title">
          <p>{this.state.item ? this.state.item.title.rendered : "234"}</p>
        </div>
      </div>
    );
  }
}

export default Carousel;
